import { render, staticRenderFns } from "./rh_dashboard_diretoria.vue?vue&type=template&id=03124600&scoped=true&"
import script from "./rh_dashboard_diretoria.vue?vue&type=script&lang=js&"
export * from "./rh_dashboard_diretoria.vue?vue&type=script&lang=js&"
import style0 from "./rh_dashboard_diretoria.vue?vue&type=style&index=0&id=03124600&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03124600",
  null
  
)

export default component.exports